import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QueryKey } from '@/types/query';
import { userClient } from './client';

type SaveUserProfilePayload = {
  phoneNumber: string | null;
};

export const useSaveUserProfileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: SaveUserProfilePayload) => {
      await userClient.saveUserProfile({
        phone_number: payload.phoneNumber,
      });

      return true;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.useCurrentUserQuery] });
    },
  });
};
